import {Select} from 'antd';
import {Line} from '@ant-design/plots';

import DataLargeBlock from "../../containers/DataLargeBlock";

import styles from "./line-chart.module.scss";

// import config from "./config";

const config = {
    padding: 'auto',
    xField: 'Date',
    yField: 'scales',
    xAxis: {
        // type: 'timeCat',
        tickCount: 5,
    },
};

const LineChart = ({title, data}) => {

    const lineConfig = {...config, data};

    return (
        <DataLargeBlock>
            <div className={styles.chart}>
                <div className={styles.heading}>
                    <p className={styles.title}>{title}</p>
                    <div className={styles.headingSearch}>
                        {/*<Select placeholder="Registered Users" className={styles.select}/>*/}

                        {/*<div className={styles.periodBox}>Specific period</div>*/}
                    </div>
                </div>
                <Line {...lineConfig} />
            </div>
        </DataLargeBlock>
    )
};

export default LineChart;
